module.exports = __webpack_public_path__ + "static/media/SmartLoans_v2.1253288a.png";